var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoVer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "no-ver",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_88",
    "data-name": "Rect\\xE1ngulo 88",
    width: 20.392,
    height: 16.4,
    transform: "translate(0 0)",
    fill: "none"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_22",
    "data-name": "Rect\\xE1ngulo 22",
    width: 24,
    height: 24,
    fill: "#1c1c1c",
    opacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_175",
    "data-name": "Grupo 175",
    transform: "translate(2 3.933)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_174",
    "data-name": "Grupo 174",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_47",
    "data-name": "Trazado 47",
    d: "M3.318.22A.75.75,0,1,0,2.256,1.28L3.945,2.973A10.313,10.313,0,0,0,.3,6.952a2.847,2.847,0,0,0,0,2.535,11.048,11.048,0,0,0,9.9,5.865,11.464,11.464,0,0,0,4.952-1.15l1.974,1.978a.75.75,0,0,0,1.062-1.06ZM7.7,6.732l.654.656a2.007,2.007,0,0,0-.182.831A2.028,2.028,0,0,0,10.2,10.247a2.007,2.007,0,0,0,.827-.18l.654.656a2.88,2.88,0,0,1-1.481.42A2.928,2.928,0,0,1,7.272,8.219,2.883,2.883,0,0,1,7.7,6.732m2.5,7.12A9.538,9.538,0,0,1,1.639,8.814a1.339,1.339,0,0,1,0-1.19,8.858,8.858,0,0,1,3.394-3.56L6.789,5.823a4.135,4.135,0,0,0-.767,2.4A4.179,4.179,0,0,0,10.2,12.393a4.129,4.129,0,0,0,2.388-.761l1.432,1.435a9.937,9.937,0,0,1-3.82.785"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_48",
    "data-name": "Trazado 48",
    d: "M20.094,6.952a11.05,11.05,0,0,0-9.9-5.866A11.615,11.615,0,0,0,7.118,1.5L8.365,2.752A10.18,10.18,0,0,1,10.2,2.586a9.536,9.536,0,0,1,8.556,5.038,1.332,1.332,0,0,1,0,1.19,8.65,8.65,0,0,1-1.871,2.474l1.059,1.061a10.138,10.138,0,0,0,2.154-2.863,2.851,2.851,0,0,0,0-2.534"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVer);
export default __webpack_public_path__ + "static/media/no-ver.2c6ca0f2aea296b5c6ba010390b0b336.svg";
export { ForwardRef as ReactComponent };